import React, { useContext, useMemo } from 'react';
import { useState } from 'react';
import {
	ActionWrapper,
	TreeNodeChildren,
	TreeNodeContainer,
	TreeNodeTitle,
	VisibilityWrapper,
} from './CategoryHierarchy.styles';
import { ApButtonIcon, ApButtonText } from '@alixpartners/ui-components';
import { allOption } from 'CategoryManagement/utils';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';

const truncateString = (inputString, level) => {
	if (inputString.length > 20) {
		if (level === 3 || level === 4) {
			return inputString.slice(0, -6) + '...';
		} else {
			return inputString;
		}
	} else {
		return inputString;
	}
};

const CategoryHierarchy = ({ node, onCategoryDelete }) => {
	const { id, title, children } = node;
	const {
		currentSelectCategory,
		handleCategoryChange,
		taxonomyType,
	} = useContext(CategoryManagementContext);
	const [expanded, setExpanded] = useState(false);

	const onTreeExpand = () => setExpanded(!expanded);

	const onCategorySelect = () => handleCategoryChange(id);

	const isSelectedCategory = useMemo(
		() => currentSelectCategory.categoryName === id,
		[currentSelectCategory.categoryName, id]
	);

	const categoryLevel = id.split('/').filter(el => el !== '').length;

	const preventOnClick = useMemo(
		() => {
			if (categoryLevel === 1 && id === allOption.id) {
				return false;
			}
			if (taxonomyType === 3 && (categoryLevel === 5 || categoryLevel === 1)) {
				return true;
			}
			if ((taxonomyType === 1 || taxonomyType === 2) && categoryLevel === 4) {
				return true;
			}
			return false;
		},
		[taxonomyType, categoryLevel, id]
	);

	return (
		<TreeNodeContainer>
			<TreeNodeTitle>
				<VisibilityWrapper isVisible={children.length > 0}>
					{expanded ? (
						<ApButtonIcon
							title="Expand Less"
							className="expandLess"
							iconName="expand_less"
							iconProps={{ material: true }}
							onClick={onTreeExpand}
						/>
					) : (
						<ApButtonIcon
							title="Expand More"
							className="expandMore"
							iconName="expand_more"
							iconProps={{ material: true }}
							onClick={onTreeExpand}
						/>
					)}
				</VisibilityWrapper>
				<ActionWrapper isSelectedCategory={isSelectedCategory}>
					{title !== allOption.title && (
						<ApButtonIcon
							title="Delete Category"
							iconName="delete"
							className="delete"
							onClick={() => onCategoryDelete(id)}
							style={{ cursor: 'pointer' }}
						/>
					)}
					<ApButtonText
						className="category-title"
						title={title}
						onClick={!preventOnClick ? onCategorySelect : null}
						size={8}
						style={
							preventOnClick ? { cursor: 'not-allowed' } : { cursor: 'pointer' }
						}
					>
						{truncateString(title, categoryLevel)}
					</ApButtonText>
				</ActionWrapper>
			</TreeNodeTitle>
			{expanded &&
				children &&
				children.length > 0 && (
					<TreeNodeChildren>
						{children.map(child => (
							<CategoryHierarchy
								key={child.id}
								node={child}
								onCategoryDelete={onCategoryDelete}
							/>
						))}
					</TreeNodeChildren>
				)}
		</TreeNodeContainer>
	);
};

export default CategoryHierarchy;
